import React from "react";
import { Link } from "react-router-dom";
import { CloudLightning } from "lucide-react";

const NotFound = () => (
  <div className="max-w-3xl mx-auto px-6 py-24 text-center">
    <CloudLightning className="w-14 h-14 mx-auto text-red-500" />
    <h1 className="display text-4xl font-bold mt-4">Signal lost</h1>
    <p className="text-slate-400 mt-2">The page you're looking for drifted out of range.</p>
    <Link to="/" className="inline-block mt-6 px-5 py-2.5 rounded-md bg-red-600 hover:bg-red-500 text-white text-sm font-semibold">Back to Home</Link>
  </div>
);

export default NotFound;
